<template>
  <div class="info">
    <div class="labels">
      <p class="labels--main">{{ label }}</p>
      <p class="labels--second">/ person</p>
    </div>
    <p class="value">
      <slot>0.00</slot>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'result-info',
  props: { label: { type: String, required: true } },
});
</script>

<style lang="scss" scoped>
.info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5rem;
  margin-bottom: 2rem;
  align-items: center;
}

.labels {
  &--main {
    color: $white;
    font-weight: 700;
  }

  &--second {
    color: $darker-cyan;
  }
}

.value {
  text-align: right;
  color: $primary-cyan;
  font-weight: 700;
  font-size: 2.5rem;

  &::before {
    content: '$';
  }
}
</style>
